goog.provide("shadow.js.shim.module$$carbon$icons_react$es$ChevronUp$default");
shadow.js.shim.module$$carbon$icons_react$es$ChevronUp$default = shadow.js.require(356, {}).default;
